import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import ShowPdfInvoice from "../components/InvoicePDF";
class ShowPdfInvoiceContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      allCustomers: [],
      appBarName: null,
      customersList: [],
      tempProducts: [],
      selectedInvoiceDeals: []
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    let deals = whichProps.allDeals;
    let customerId = this.props.match.params.customerId;
    let allCustomersData = whichProps.allCustomers;
    let allCustomers = whichProps.allCustomers.find(
      customer => customer.id === this.props.match.params.customerId
    );
    let allInvoices = whichProps.allInvoices;
    const invoicedDealsId = [];
    const invalidCustomers = [];
    let allCustomerDeals = whichProps.allCustomerDeals;
    let products = whichProps.products;
    let customersList = [];
    let tempCustomers = [];
    let tempAllCustomers = [];
    const tempProducts = [];
    let unPaidInvocies = whichProps.unPaidInvocies;
    if (products.length > 0) {
      products.map(products => tempProducts.push(products.productName));
    }
    this.setState({ tempProducts }, () => {
      console.log(this.state.tempProducts);
    });
    allInvoices.length > 0
      ? allInvoices
          .filter(
            selectedInvoice =>
              selectedInvoice.id === this.props.match.params.invoiceId
          )
          .map(dealsId =>
            dealsId.dealsId.map(data => invoicedDealsId.push(data))
          )
      : console.log("No Invoices Generated Yet");
    this.setState({ selectedInvoiceDeals: invoicedDealsId });
    deals
      .filter(
        deals =>
          (deals.buyerId === customerId || deals.sellerId === customerId) &&
          invoicedDealsId.includes(deals.id)
      )
      .map(deals => {
        if (invoicedDealsId.length > 0) {
          if (
            invoicedDealsId.find(
              invoiceDeals => invoiceDeals.dealId !== deals.id
            )
          ) {
            let a = deals;
            if (customerId === deals.buyerId) {
              a.customerName = deals.sellerName;
              a.customerId = deals.sellerId;
            }
            if (customerId === deals.sellerId) {
              a.customerName = deals.buyerName;
              a.customerId = deals.buyerId;
            }
            tempCustomers.push(a);
          }
        } else {
          let a = deals;
          if (customerId === deals.buyerId) {
            a.customerName = deals.sellerName;
            a.customerId = deals.sellerId;
          }
          if (customerId === deals.sellerId) {
            a.customerName = deals.buyerName;
            a.customerId = deals.buyerId;
          }
          tempCustomers.push(a);
        }
        return tempCustomers;
      });
    customersList = [...new Set(tempCustomers)];
    this.setState({ customersList });
  };
  render() {
    const { customersList, tempProducts, selectedInvoiceDeals } = this.state;
    const {
      unPaidInvoices,
      allCustomers,
      allDeals,
      currentUser,
      invoicePrintData,
      user
    } = this.props;
    return (
      <div>
        <Route
          exact
          path="/invoice/:customerId/showPdfInvoice/:invoiceId"
          render={props => (
            <ShowPdfInvoice
              {...props}
              customersList={customersList}
              unPaidInvoices={unPaidInvoices.filter(
                data => data.id === this.props.match.params.invoiceId
              )}
              invoiceId={this.props.match.params.invoiceId}
              customerId={this.props.match.params.customerId}
              allDeals={allDeals}
              allCustomers={allCustomers.find(
                currentCustomer =>
                  currentCustomer.id === this.props.match.params.customerId
              )}
              user={user}
              currentUser={currentUser}
              products={tempProducts}
              invoicePrintData={invoicePrintData.find(
                invoicePrintData => invoicePrintData.userId === user.uid
              )}
              selectedInvoiceDeals={selectedInvoiceDeals}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(ShowPdfInvoiceContainer)));
